module.exports = __webpack_public_path__ + "img/77.385ab5ab.png";